<template>
  <div>
    <canvas id="c" class="d-flex vh-100 justify-content-center align-items-center"></canvas>

    <b-row class="p-5 text-center">
      <b-col>
        <b-button @click="decrement">-</b-button> Time Offset: {{ timeOffset }}
        <b-button @click="increment">+</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Clock",
  props: {
    size: {
      type: String,
      default: "800",
    },
    colour: {
      type: String,
      default: "red",
    },
    state: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      vueCanvas: null,
      displayColour: "white",
      timeOffset: 0,
    };
  },

  watch: {
    state: function() {
      console.log(this.state);
      if (this.state) {
        this.displayColour = this.colour;
      } else {
        this.displayColour = "white";
      }
    },
  },

  computed: {
    center: function() {
      return this.size / 2;
    },

    hradius: function() {
      return (1.1 * this.size) / 2.5;
    },
    secradius: function() {
      return this.size / 2.5;
    },
    dotSize: function() {
      return this.size / 60;
    },
  },

  mounted() {
    var c = document.getElementById("c");
    var ctx = c.getContext("2d");
    ctx.canvas.width = this.size;
    ctx.canvas.height = this.size;
    this.vueCanvas = ctx;
    this.pollTime();
  },

  methods: {
    decrement() {
      this.timeOffset -= 1;
    },
    increment() {
      this.timeOffset += 1;
    },
    time() {
      let date = new Date();
      let hours = date
        .getHours()
        .toString()
        .padStart(2, "0");

      hours = String(parseInt(hours) + this.timeOffset);
      let minutes = date
        .getMinutes()
        .toString()
        .padStart(2, "0");
      let seconds = date
        .getSeconds()
        .toString()
        .padStart(2, "0");
      let time = { hours, minutes, seconds };
      this.draw(time);
    },

    pollTime() {
      this.polling = setInterval(() => {
        this.time();
      }, 1);
    },

    draw(time) {
      this.vueCanvas.clearRect(
        0,
        0,
        this.vueCanvas.canvas.width,
        this.vueCanvas.canvas.height
      );
      //set Text time:
      this.vueCanvas.fillStyle = this.displayColour;
      this.vueCanvas.fill();
      let fontSize = this.size / 5;
      this.vueCanvas.font = `bold ${fontSize}px helvetica`;
      this.vueCanvas.textAlign = "center";
      this.vueCanvas.fillText(
        `${time.hours}:${time.minutes}`,
        this.center,
        this.center
      );
      this.vueCanvas.fillText(
        `${time.seconds}`,
        this.center,
        this.center + this.size / 5
      );

      //To get the dots in sync with the seconds
      let secdeg = ((time.seconds + 1) * 6) / 10;

      //Draw second markers
      let smx = 0;
      let smy = 0;
      while (smx < secdeg) {
        this.vueCanvas.beginPath();

        this.vueCanvas.arc(
          this.paraeqsmx(smx),
          this.paraeqsmy(smy),
          this.dotSize - 2,
          0,
          2 * Math.PI
        );
        this.vueCanvas.fillStyle = this.displayColour;
        this.vueCanvas.fill();
        this.vueCanvas.stroke();
        smy += 6;
        smx += 6;
      }

      //Draw Hour markers
      smx = 0;
      smy = 0;
      while (smx < 360) {
        this.vueCanvas.beginPath();

        this.vueCanvas.arc(
          this.paraeqshx(smx),
          this.paraeqshy(smy),
          this.dotSize,
          0,
          2 * Math.PI
        );
        this.vueCanvas.fillStyle = this.displayColour;
        this.vueCanvas.fill();
        this.vueCanvas.stroke();
        smy += 30;
        smx += 30;
      }
    },

    paraeqsmx(smx) {
      return this.center - this.secradius * Math.cos(this.toRadians(smx + 90));
    },
    paraeqsmy(smy) {
      return this.center - this.secradius * Math.sin(this.toRadians(smy + 90));
    },
    paraeqshx(shx) {
      //  Equations for hour markers
      return this.center - this.hradius * Math.cos(this.toRadians(shx + 90));
    },
    paraeqshy(shy) {
      return this.center - this.hradius * Math.sin(this.toRadians(shy + 90));
    },
    toRadians(angle) {
      return angle * (Math.PI / 180);
    },
  },
  sockets: {},

  components: {},

  beforeMount() {},
};
</script>

<style>
body {
  background: black;
}
</style>
